<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input
          @keyup.enter.native="handleFilter"
          size="mini"
          style="width: 200px;"
          class="filter-item"
          placeholder="编码 / 名称"
          v-model="listQuery.key"
        ></el-input>
        <el-select v-model="listQuery.type" size="mini" class="filter-item" style="width: 120px;" placeholder="全部类型">
          <el-option label="全部类型" :value="0"></el-option>
          <el-option label="聊天" :value="1"></el-option>
          <el-option label="翻译" :value="2"></el-option>
        </el-select>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <el-button class="filter-item" size="mini" type="primary" icon="el-icon-plus" @click="openCreate">新增配置</el-button>
      </div>
    </sticky>

    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%; padding: 10px;">
        <el-table :data="list" v-loading="listLoading" border size="mini" style="width: 100%;">
          <el-table-column prop="code" label="编码" width="150"></el-table-column>
          <el-table-column prop="name" label="名称" width="140"></el-table-column>
          <el-table-column label="类型" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.type === 2 ? 'warning' : ''">
                {{ scope.row.type === 2 ? '翻译' : '聊天' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="音色" min-width="180">
            <template slot-scope="scope">
              {{ voiceText(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="目标语言" min-width="150">
            <template slot-scope="scope">
              {{ languageText(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="maxHistoryTurns" label="历史轮数" width="90" align="center"></el-table-column>
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.enabled ? 'success' : 'info'">
                {{ scope.row.enabled ? '启用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="70" align="center"></el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="color: #F56C6C;" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange"
        />
      </div>

      <el-dialog
        v-el-drag-dialog
        :title="dialogStatus === 'create' ? '新增提示词配置' : '编辑提示词配置'"
        :visible.sync="dialogVisible"
        width="780px"
        :close-on-click-modal="false"
      >
        <el-form ref="dataForm" :model="form" label-width="110px" size="mini">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="唯一编码" required>
                <el-input v-model="form.code" placeholder="小写字母、数字、下划线、中划线、点号" :disabled="dialogStatus === 'update'" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="显示名称" required>
                <el-input v-model="form.name" placeholder="如 儿童故事" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="配置类型" required>
            <el-radio-group v-model="form.type" :disabled="dialogStatus === 'update'" @change="handleTypeChange">
              <el-radio :label="1">聊天（多轮，保留上下文）</el-radio>
              <el-radio :label="2">翻译（单轮，结束后释放连接）</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="系统提示词">
            <el-input
              type="textarea"
              :rows="7"
              v-model="form.systemPrompt"
              placeholder="翻译类型请使用 {targetLanguage} 占位，例如：将用户的话翻译成{targetLanguage}，只输出译文。"
            />
            <div class="field-tip">
              共 {{ (form.systemPrompt || '').length }} 字，建议不超过 800 字（提示词每轮都会作为上下文重发，按输入文本计费）
              <span v-if="form.type === 2 && (form.systemPrompt || '').indexOf('{targetLanguage}') < 0" class="warn-tip">
                · 当前提示词未包含 {targetLanguage} 占位符，目标语言不会被插入
              </span>
            </div>
          </el-form-item>

          <el-form-item label="音色列表" required>
            <el-table :data="form.voices" size="mini" border style="width: 100%;">
              <el-table-column label="音色 key" width="200">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.key" placeholder="如 longanqian" />
                </template>
              </el-table-column>
              <el-table-column label="显示名称">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.name" placeholder="如 龙安倩 · 温柔女声" />
                </template>
              </el-table-column>
              <el-table-column label="插值名（可空）" width="180">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.promptName" placeholder="默认同显示名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="70" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="removeRow(form.voices, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button size="mini" icon="el-icon-plus" style="margin-top: 6px;" @click="form.voices.push(emptyOption())">新增音色</el-button>
          </el-form-item>

          <el-form-item label="默认音色">
            <el-select v-model="form.defaultVoice" clearable placeholder="未指定时取列表第一项" style="width: 260px;">
              <el-option v-for="item in voiceOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <template v-if="form.type === 2">
            <el-form-item label="目标语言" required>
              <el-table :data="form.languages" size="mini" border style="width: 100%;">
                <el-table-column label="语言 key" width="200">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.key" placeholder="如 en-US" />
                  </template>
                </el-table-column>
                <el-table-column label="显示名称">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.name" placeholder="如 英语（美国）" />
                  </template>
                </el-table-column>
                <el-table-column label="插值名（可空）" width="180">
                  <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.promptName" placeholder="如 英语" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="70" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="removeRow(form.languages, scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button size="mini" icon="el-icon-plus" style="margin-top: 6px;" @click="form.languages.push(emptyOption())">新增语言</el-button>
            </el-form-item>
          </template>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="历史轮数">
                <el-input-number v-model="form.maxHistoryTurns" :min="1" :max="50" size="mini" :disabled="form.type === 2" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联网搜索">
                <el-switch v-model="form.enableSearch" :disabled="form.type === 2" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="排序">
                <el-input-number v-model="form.sort" :min="0" size="mini" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="是否启用">
                <el-switch v-model="form.enabled" />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="备注">
                <el-input v-model="form.remark" placeholder="选填" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer">
          <el-button size="mini" @click="dialogVisible = false">取消</el-button>
          <el-button size="mini" type="primary" :loading="submitting" @click="submit">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as profiles from '@/api/realtimePromptProfiles'
import waves from '@/directive/waves'
import Sticky from '@/components/Sticky'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'

const emptyOption = () => ({ key: '', name: '', promptName: '' })

// 后端同样会校验，这里前置一份，避免无谓的往返
// 允许英文句点（如 v1.0、zh-CN.female），首字符仍须为字母或数字；与 RealtimePromptProfileApp 的正则保持一致
const KEY_REGEX = /^[A-Za-z0-9][A-Za-z0-9._-]*$/
const CODE_REGEX = /^[a-z0-9][a-z0-9._-]*$/

export default {
  name: 'realtimePromptProfile',
  components: { Sticky, Pagination },
  directives: { waves, elDragDialog },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      submitting: false,
      listQuery: {
        page: 1,
        limit: 20,
        key: undefined,
        type: 0,
      },
      dialogVisible: false,
      dialogStatus: 'create',
      form: this.buildEmptyForm(),
    }
  },
  computed: {
    voiceOptions() {
      return (this.form.voices || [])
        .filter((item) => item.key)
        .map((item) => ({ value: item.key.trim(), label: item.name || item.key }))
    },
  },
  created() {
    this.getList()
  },
  methods: {
    buildEmptyForm() {
      return {
        id: 0,
        code: '',
        name: '',
        type: 1,
        systemPrompt: '',
        voices: [emptyOption()],
        languages: [],
        defaultVoice: '',
        maxHistoryTurns: 10,
        enableSearch: false,
        sort: 0,
        enabled: true,
        remark: '',
      }
    },
    emptyOption() {
      return emptyOption()
    },
    voiceText(row) {
      const list = row.voices || []
      return list.length === 0 ? '-' : list.map((item) => item.name || item.key).join('、')
    },
    languageText(row) {
      const list = row.languages || []
      return list.length === 0 ? '-' : list.map((item) => item.name || item.key).join('、')
    },
    getList() {
      this.listLoading = true
      profiles
        .getList(this.listQuery)
        .then((response) => {
          this.list = response.data || []
          this.total = response.count || 0
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleTypeChange(value) {
      if (value === 1) {
        // 聊天类型不保留目标语言，避免切换后残留旧值
        this.form.languages = []
        this.form.maxHistoryTurns = 10
        this.form.enableSearch = false
      } else {
        this.form.maxHistoryTurns = 1
        this.form.enableSearch = false
        if (this.form.languages.length === 0) {
          this.form.languages = [emptyOption()]
        }
      }
    },
    openCreate() {
      this.form = this.buildEmptyForm()
      this.dialogStatus = 'create'
      this.dialogVisible = true
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        code: row.code,
        name: row.name,
        type: row.type,
        systemPrompt: row.systemPrompt || '',
        voices: (row.voices || []).map((item) => ({ key: item.key, name: item.name, promptName: item.promptName || '' })),
        languages: (row.languages || []).map((item) => ({ key: item.key, name: item.name, promptName: item.promptName || '' })),
        defaultVoice: row.defaultVoice || '',
        maxHistoryTurns: row.maxHistoryTurns || 10,
        enableSearch: !!row.enableSearch,
        sort: row.sort || 0,
        enabled: row.enabled !== false,
        remark: row.remark || '',
      }
      if (this.form.voices.length === 0) {
        this.form.voices = [emptyOption()]
      }
      if (this.form.type === 2 && this.form.languages.length === 0) {
        this.form.languages = [emptyOption()]
      }
      this.dialogStatus = 'update'
      this.dialogVisible = true
    },
    removeRow(list, index) {
      list.splice(index, 1)
    },
    normalizeOptions(list, label) {
      const result = []
      const seen = {}
      for (const item of list || []) {
        const key = (item.key || '').trim()
        if (!key) {
          continue
        }
        if (!KEY_REGEX.test(key)) {
          return { error: `${label}标识「${key}」只能由字母、数字、下划线、中划线和点号组成，且以字母或数字开头` }
        }
        if (seen[key]) {
          return { error: `${label}标识「${key}」重复` }
        }
        seen[key] = true
        const name = (item.name || '').trim()
        if (!name) {
          return { error: `${label}「${key}」的显示名称不能为空` }
        }
        result.push({
          key,
          name,
          promptName: (item.promptName || '').trim() || null,
        })
      }
      return { list: result }
    },
    validate() {
      const code = (this.form.code || '').trim()
      if (!CODE_REGEX.test(code)) {
        return { error: '唯一编码只能由小写字母、数字、下划线、中划线和点号组成，且以字母或数字开头' }
      }
      if (!(this.form.name || '').trim()) {
        return { error: '显示名称不能为空' }
      }
      const voices = this.normalizeOptions(this.form.voices, '音色')
      if (voices.error) {
        return { error: voices.error }
      }
      if (voices.list.length === 0) {
        return { error: '至少需要配置一个音色' }
      }
      let languages = []
      if (this.form.type === 2) {
        const result = this.normalizeOptions(this.form.languages, '目标语言')
        if (result.error) {
          return { error: result.error }
        }
        if (result.list.length === 0) {
          return { error: '翻译类型至少需要配置一个目标语言' }
        }
        languages = result.list
      }
      return {
        payload: {
          id: this.form.id,
          code,
          name: this.form.name.trim(),
          type: this.form.type,
          systemPrompt: this.form.systemPrompt || '',
          voices: voices.list,
          languages,
          defaultVoice: (this.form.defaultVoice || '').trim(),
          maxHistoryTurns: this.form.maxHistoryTurns,
          enableSearch: this.form.type === 2 ? false : this.form.enableSearch,
          sort: this.form.sort || 0,
          enabled: this.form.enabled,
          remark: this.form.remark || '',
        },
      }
    },
    submit() {
      const result = this.validate()
      if (result.error) {
        this.$message({ message: result.error, type: 'error' })
        return
      }
      this.submitting = true
      const request = this.dialogStatus === 'create' ? profiles.add(result.payload) : profiles.update(result.payload)
      request
        .then(() => {
          this.dialogVisible = false
          this.$notify({
            title: '成功',
            message: this.dialogStatus === 'create' ? '创建成功' : '更新成功，已刷新缓存',
            type: 'success',
            duration: 2000,
          })
          this.getList()
        })
        .catch(() => {})
        .finally(() => {
          this.submitting = false
        })
    },
    handleDelete(row) {
      this.$confirm(`确认删除配置「${row.name}」？已被账号引用的配置无法删除。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          profiles.del([row.id]).then(() => {
            this.$notify({ title: '成功', message: '删除成功', type: 'success', duration: 2000 })
            this.getList()
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
.field-tip {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.warn-tip {
  color: #E6A23C;
}
</style>
